import React, { useState, createContext } from 'react'

export const GlobalIsRegisteredContext = createContext();

const GlobalIsRegisteredContextProvider = (props) => {
  const [getGlobalIsRegistered, setGlobalIsRegistered] = useState(false)

  return (
    <GlobalIsRegisteredContext.Provider value={{getGlobalIsRegistered, setGlobalIsRegistered}}>
      {props.children}
    </GlobalIsRegisteredContext.Provider>
  )
}

export default GlobalIsRegisteredContextProvider;
